import React, { useState } from 'react'
import { ArrowDown, ArrowUp } from "lucide-react"
import Subtract from '../../../../img/news-announcement/Subtract.png'

const NewsMobile = ({ news, handleNavigate, isCustomImage, nextSlide, prevSlide, currentIndex, setLoading }) => {

  return (
    <div className='news-container-mobile'>
      <h1>News</h1>
      <div className='slider-container' onClick={() => handleNavigate(news[currentIndex]?.Type, news[currentIndex]?.Id)}>
        {news[currentIndex]?.IconUrl ? <img
          src={
            isCustomImage(news[currentIndex]?.IconUrl)
              ? `/img/vendors/news/${news[currentIndex]?.IconUrl}.jpg`
              : `api/Announcement/Image/${news[currentIndex]?.IconUrl}`
          }
          alt="news-image"
          onLoad={() => setLoading(false)}
        /> : (
          <>
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '213px', width: '100%' }}>
              <h1 className='text-secondary text-center'>Please stay tuned</h1>
              <h1 className='text-secondary text-center'>for the</h1>
              <h1 className='text-secondary text-center'>news soon.</h1>
            </div>
          </>
        )}
      </div>
      <div className='subtract'>
        <img src={Subtract} alt="subtract" />
      </div>
      <div className="slider-button mobile-slider-button">
        <div className='arrow-button' onClick={prevSlide}>
          <ArrowUp size={24} />
        </div>
        <div className='arrow-button' onClick={nextSlide}>
          <ArrowDown size={24} />
        </div>
      </div>
    </div>
  )
}

export default NewsMobile